import { render, staticRenderFns } from "./InterfaceDocking.vue?vue&type=template&id=15dc87fe&scoped=true&"
import script from "./InterfaceDocking.vue?vue&type=script&lang=js&"
export * from "./InterfaceDocking.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceDocking.vue?vue&type=style&index=0&id=15dc87fe&lang=less&scoped=true&"
import style1 from "./InterfaceDocking.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc87fe",
  null
  
)

export default component.exports